import { SectionShell } from "../components/home/SectionShell";
import { SectionTitle } from "../components/home/SectionTitle";

const whyUltra24 = [
  {
    title: "Tren Ultra Running",
    description:
      "Pertumbuhan komunitas endurance di Indonesia membuka momentum kuat untuk event ultra berdurasi panjang.",
  },
  {
    title: "Sport Tourism Impact",
    description:
      "Format event 24 jam mendorong ekonomi lokal dari sisi kunjungan, hospitality, dan ekosistem olahraga.",
  },
  {
    title: "Strategic Venue",
    description:
      "Venue stadion memudahkan kontrol keamanan, support station, pencahayaan, dan akses media.",
  },
  {
    title: "Branding Opportunity",
    description:
      "Eksposur sepanjang hari memberi ruang kolaborasi brand yang lebih kuat untuk sponsor dan partner.",
  },
];

const raceRoutePoints = [
  "Lintasan atletik 400m per putaran",
  "Permukaan sintetis dalam stadion",
  "Sistem pencatatan lap & waktu resmi",
  "Dukungan pencahayaan stadion aktif",
];

const missionGoals = [
  "Mengembangkan ultra running di Indonesia",
  "Menemukan bibit atlet potensial nasional",
  "Mendorong sport tourism JABODETABEK",
  "Platform kompetisi untuk atlet & komunitas",
];

export const Ultra24WhySection = () => {
  return (
    <SectionShell id="why-ultra24" className="bg-[#f3f4f6]">
      <SectionTitle
        title="Kenapa Event Ini Penting"
        subtitle="Empat pilar strategis dari sisi tren, venue, dampak, dan branding."
        align="center"
      />

      <div className="grid gap-4 lg:grid-cols-[1.6fr_1fr]">
        <div className="grid gap-4">
          <article className="rounded-2xl border border-slate-200 bg-white p-4">
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Misi Event</p>
            <h3 className="mt-2 text-2xl font-black text-slate-900 leading-tight">Misi INDONESIA ULTRA 24</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-600 max-w-prose">
              Penyelenggaraan INDONESIA ULTRA 24 bertujuan menciptakan standar baru dalam ultra running stadium di Indonesia, memberikan pengalaman kompetisi kelas dunia bagi para pegiat lari jarak jauh.
            </p>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
              {missionGoals.map((goal) => (
                <div key={goal} className="flex items-start gap-3">
                  <div className="mt-1 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-red-50">
                    <svg className="h-2.5 w-2.5 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="4">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="text-sm font-medium leading-tight text-slate-600">{goal}</span>
                </div>
              ))}
            </div>
          </article>

          <article className="rounded-2xl border border-slate-200 bg-white p-4">
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">Venue & Operasional</p>
            <h3 className="mt-2 text-2xl font-black text-slate-900 leading-tight">Kekuatan Venue & Operasional</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-600 max-w-prose">
              Mengambil lokasi di stadion dengan fasilitas internasional, event ini menghadirkan kontrol operasional penuh dan atmosfer yang memikat namun aman bagi pelari selama 24 jam penuh.
            </p>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
              {raceRoutePoints.map((point) => (
                <div key={point} className="flex items-start gap-3">
                  <div className="mt-1 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-red-50">
                    <svg className="h-2.5 w-2.5 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="4">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="text-sm font-medium leading-tight text-slate-600">{point}</span>
                </div>
              ))}
            </div>
          </article>
        </div>

        <article className="rounded-2xl border border-slate-200 bg-white p-4">
          <div className="flex items-center justify-between gap-3">
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-500">Pilar Strategis</p>
          </div>
          <div className="mt-4 divide-y divide-slate-200">
            {whyUltra24.map((item, index) => (
              <div key={item.title} className="py-3 first:pt-0 last:pb-0">
                <p className="text-xs font-semibold text-red-600">0{index + 1}</p>
                <h3 className="mt-1 text-lg font-bold leading-tight text-slate-900">{item.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{item.description}</p>
              </div>
            ))}
          </div>
        </article>
      </div>
    </SectionShell>
  );
};
